import React from 'react';

export type BgisLegendInfoDetailsProps = {
  children?: React.ReactNode;
};

export const BgisLegendInfoDetails : React.FC<BgisLegendInfoDetailsProps> = ({ children }) => {
  return (
    <div className="bgis-legend-info-details">
      <span className="bgis-card bgis-body1 bgis-scroll">{children}</span>
    </div>
  );
};
